import React from "react";
import withIconComponent from "../withIconComponent";

var Video = function Video() {
  return /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h16z",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.89h5.005v4.233H9.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8l6 4-6 4z",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }));
};

export default withIconComponent("UiVideo", false)(Video);